let loading = null

export default function loadPaypal() {
  if (!loading) {
    loading = new Promise(async resolve => {
      const scriptElement = document.createElement('script')
      scriptElement.src = `https://www.paypal.com/sdk/js?client-id=${ process.env.PAYPAL_CLIENT_ID }&disable-funding=credit`
      scriptElement.onload = () => { resolve(window.paypal) }
      document.body.appendChild(scriptElement)
    })
  }
  return loading
}
